import { useFetchDocumentType } from './useFetchDocumentType'
import { useQueryClientUtils } from '../../useQueryClientUtils'
import { queryKeys as documentTypeQueryKeys } from '../../document-type/useQueryDocumentType'
import { queryKeys as documentQueryKeys, type QueryDocumentByIdCacheData } from '../useQueryDocument'

const update = () => {
  const { update } = useFetchDocumentType()
  const queryClient = useQueryClient()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: update,
    onMutate: (variables) => {
      cancelQueries([
        documentTypeQueryKeys.all._def,
        documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      ])
    },
    onError: (_, variables) => {
      invalidateQueries([
        documentTypeQueryKeys.all._def,
        documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      ])
    },
    onSuccess: (responseData, variables) => {
      queryClient.setQueriesData<QueryDocumentByIdCacheData>({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          data: {
            ...oldData.data,
            document_types: responseData.data,
          },
        }
      }, {
        updatedAt: Date.now(),
      })
    },
  })
}

export const useMutationDocumentType = {
  update,
}
